import axios from "axios"
import { Dispatch } from "react"
import Cookies from "universal-cookie"
import { LoginDto } from "../../../models/LoginDto"
import { LoginAction } from "../../actions/Login/loginAction"
import { LoginActionType } from "../../actionTypes/Login"
import { COOKIE_MAX_AGE, REACT_APP_BASE_URL_CC_NEW } from "../../../configs/const"
import qs from "qs"

export const login = (loginDto: LoginDto) => {
    return (dispatch: Dispatch<LoginAction>) => {
        try {
console.log('---', process.env.REACT_APP_API_URL);
            axios({
                method: 'post',
                url: process.env.REACT_APP_API_URL + REACT_APP_BASE_URL_CC_NEW + 'login',
                data: qs.stringify(loginDto),
                headers: {
                    'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                }
            }).then((response) => {
                console.log(123, response)
                let obj = {
                    accessToken: response.data.access_token,
                    refreshToken: response.data.refresh_token,
                    isSuperUser: response.data.isSuperUser,
                    branches: response.data.branches
                }
                const cookies = new Cookies();
                if (cookies.get('auth') != null) {
                    cookies.remove('auth', { path: '/' })
                }
                // cookies.set('auth', obj)
                //alert(new Date(Date.now()+100))
                cookies.set('auth', obj, { path: '/', maxAge: COOKIE_MAX_AGE })

                dispatch({
                    // console.info('dispa');
                    type: LoginActionType.POST_LOGIN_SUCCESS,
                    payload: response.data,
                    error: '',
                    success: true,
                });
            }).catch((error) => {
                console.log(999, error)

                if (error?.response?.data) {
                 
                    dispatch({
                        type: LoginActionType.POST_LOGIN_UNSUCCESS,
                        error: error.response.data.message,
                        success: false,
                        payload: undefined
                    })
                } else {
                    dispatch({
                        type: LoginActionType.POST_LOGIN_UNSUCCESS,
                        error: "Error login",
                        success: false,
                        payload: undefined
                    })
                }
            })


        } catch (error: any) {

            if (error.response.data) {
                dispatch({
                    type: LoginActionType.POST_LOGIN_UNSUCCESS,
                    error: error.response.data.errorCode,
                    success: false,
                    payload: undefined
                })
            } else {
                dispatch({
                    type: LoginActionType.POST_LOGIN_UNSUCCESS,
                    error: "Error login",
                    success: false,
                    payload: undefined
                })
            }
        }
    }
}


export const CleanLogin = () => {
    return async (dispatch: Dispatch<LoginAction>) => {
        dispatch({
            // console.info('dispa');
            type: LoginActionType.POST_LOGIN_RESET,
            payload: undefined,
            error: '',
            success: false,
        });
    }
}